module.exports = __webpack_public_path__ + "img/banker-green_1248.b546aa68.png";